import { IconDocument16 } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './OtherFilePreview.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var OtherFilePreview = function OtherFilePreview(_ref) {
  var file = _ref.file;
  var fileNameChunks = file.name.split('.');
  var fileExtension = fileNameChunks[fileNameChunks.length - 1] || '';
  return /*#__PURE__*/_jsxs("div", {
    className: styles['container'],
    children: [/*#__PURE__*/_jsx(IconDocument16, {
      color: "primary_100"
    }), /*#__PURE__*/_jsx("div", {
      className: styles['title'],
      children: fileExtension
    })]
  });
};